export default {
    /**
     * Environment settings
     */
    'env': 'dev',
    'status': '',
    'domain': '',
    'tenant': {},
    'user': {},

    /**
    * Global State
    */

    /**
    * Default empty state
    */
    'activeCard': false,
    'activeLocale': null,
    'activeLocalRecord': {},
    'activeLocalRecordSaved': {},
    'activeMarket': {},
    'activeMedia': false,
    'activeMediaLibrary': {},
    'activePolicy': {},
    'activeProduct': {},
    'activeProductGroup': {},
    'activeSequence': {},
    'allMediaLibraries': [],
    'allProductGroups': [],
    'cards': [],
    'cardsLoaded': false,
    'cardTypes': [],
    'cardIconContext': null,
    'charts': {},
    'interactionTypes': [],
    'isEditingPrimaryImage': false,
    'lastPolicyOption': {},
    'markets': [],
    'marketsLoaded': false,
    'media': [],
    'mediaDetails': null,
    'mediaGeneralUses': [],
    'mediaLoaded': false,
    'mediaTabs': [],
    'activeMediaTab': null,
    'originalSequenceCards': [],
    'policies': [],
    'productGroups': [],
    'products': [],
    'selectedCards': [],
    'selectedMedia': [],
    'selectedSequence': null,
    'sequenceCards': [],
    'sequenceLoaded': false,
    'sequences': [],
    'showAddCardToSequenceModal': false,
    'showAddMediaToCardModal': false,
    'showAddSequenceToPolicyModal': false,
    'showCardHelpModal': false,
    'showColdDeckModal': false,
    'showCreateCardModal': false,
    'showCreateLocalRecordModal': false,
    'showCreateMarketModal': false,
    'showCreateProductLocalRecordModal': false,
    'showCreateProductGroupLocalRecordModal': false,
    'showCreateMediaLibraryModal': false,
    'showCreateMediaLibraryLocalRecordModal': false,
    'showCreateProductModal': false,
    'showCreateProductGroupModal': false,
    'showDeprecateMediaModal': false,
    'showLogoutModal': false,
    'showUpdateThumbModal': false,
    'showUploadMediaModal': false,
    'showUploadProductImageModal': false,
    'showCardIconModal': false,
    'showCopyLocalRecordModal': false,
    'showCopyVolumeLinksModal': false,
    'showDeleteProductModal': false,
    'showRestoreProductModal': false,
    'showDeleteRecordModal': false,
    'unsavedSequence': false,


    /**
     * Error messages
     */
    'errors': []
};



// WEBPACK FOOTER //
// ./src/store/state.js